import React from "react";
import "./breadcrumb.component.scoped.scss";
import { Box, Typography } from "@material-ui/core";
import { history } from "react-router-guard";

interface BreadcrumbComponentProps {
  items: {
    label: string;
    path?: string;
    isActive?: boolean;
    separator?: string;
  }[];
}

export const BreadcrumbComponent = (props: BreadcrumbComponentProps) => {
  const { items } = props;
  return (
    <Box className="d-flex align-items-center my-4">
      {items.map((item, index) => (
        <Box key={index} className="d-flex align-items-center">
          <Typography
            variant="body1"
            style={{ textDecoration: item.path ? "underline" : "none" }}
            className={item.path ? "path-item" : ""}
            onClick={() => item.path && history.push(item.path)}
          >
            {item.label}
          </Typography>
          {item.separator && (
            <Typography variant="body1" className="mx-2">
              {item.separator}
            </Typography>
          )}
        </Box>
      ))}
    </Box>
  );
};
